import { render, staticRenderFns } from "./SingleMobileIconSkeleton.vue?vue&type=template&id=38cad1b0&"
import script from "./SingleMobileIconSkeleton.vue?vue&type=script&lang=js&"
export * from "./SingleMobileIconSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports